export default [
  {
    id: 1,
    img: "../images/mount-fuji.png",
    title: "Mount Fuji",
    location: "JAPAN",
    date: "12 Jan, 2021 - 24 Jan, 2021",
    description:
      "Mount Fuji is the tallest mountain in Japan, standing at 3,776 meters (12,380 feet). Mount Fuji is the single most popular tourist site in Japan, for both Japanese and foreign tourists.",
    mapLink: "https://goo.gl/maps/VAEpjW5RAjiYQPi17",
  },
  {
    id: 2,
    img: "../images/sydney.png",
    title: "Sydney Opera House",
    location: "AUSTRALIA",
    date: "27 May, 2021 - 8 Jun, 2021",
    description:
      "The Sydney Opera House is a multi-venue performing arts centre in Sydney. Located on the banks of the Sydney Harbour, it is often regarded as one of the 20th century's most famous and distinctive buildings.",
    mapLink: "https://goo.gl/maps/8nvakmvwbcw7ccgy7",
  },
  {
    id: 3,
    img: "../images/norway.png",
    title: "Geirangerfjord",
    location: "NORWAY",
    date: "01 Oct, 2021 - 18 Nov, 2021",
    description:
      "The Geiranger Fjord is a fjord in the Sunnmøre region of Møre og Romsdal county, Norway. It is located entirely in the Stranda Municipality.",
    mapLink: "https://goo.gl/maps/FXopwW7wJT1ugfEe9",
  },
];
